var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.content.title))]),(_vm.content.generateToc)?_c('Toc',{attrs:{"items":_vm.tocItems}}):_vm._e(),_c('div',{staticClass:"cms-content",domProps:{"innerHTML":_vm._s(_vm.content.content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }